module.exports = __webpack_public_path__ + "static/img/015.633eaf2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fish/yqs/015.png
// module id = JVkH
// module chunks = 0